import { render, staticRenderFns } from "./switchUserDialog.vue?vue&type=template&id=1bd2e3c4&scoped=true&"
import script from "./switchUserDialog.vue?vue&type=script&lang=js&"
export * from "./switchUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchUserDialog.vue?vue&type=style&index=0&id=1bd2e3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2e3c4",
  null
  
)

export default component.exports